import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXCalendaricon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.86719 7.99935C1.86719 5.48519 1.86719 4.22811 2.64824 3.44706C3.42928 2.66602 4.68636 2.66602 7.20052 2.66602H9.86719C12.3813 2.66602 13.6384 2.66602 14.4195 3.44706C15.2005 4.22811 15.2005 5.48519 15.2005 7.99935V9.33268C15.2005 11.8468 15.2005 13.1039 14.4195 13.885C13.6384 14.666 12.3813 14.666 9.86719 14.666H7.20052C4.68636 14.666 3.42928 14.666 2.64824 13.885C1.86719 13.1039 1.86719 11.8468 1.86719 9.33268V7.99935Z",
			stroke: "#002449",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M5.20312 2.66602V1.66602",
			stroke: "#002449",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M11.8672 2.66602V1.66602",
			stroke: "#002449",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M2.20312 6H14.8698",
			stroke: "#002449",
			strokeWidth: 1.2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5365 11.3333C12.5365 11.7015 12.238 12 11.8698 12C11.5016 12 11.2031 11.7015 11.2031 11.3333C11.2031 10.9651 11.5016 10.6667 11.8698 10.6667C12.238 10.6667 12.5365 10.9651 12.5365 11.3333Z",
			fill: "#002449"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5365 8.66667C12.5365 9.03486 12.238 9.33333 11.8698 9.33333C11.5016 9.33333 11.2031 9.03486 11.2031 8.66667C11.2031 8.29848 11.5016 8 11.8698 8C12.238 8 12.5365 8.29848 12.5365 8.66667Z",
			fill: "#002449"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20052 11.3333C9.20052 11.7015 8.90204 12 8.53385 12C8.16566 12 7.86719 11.7015 7.86719 11.3333C7.86719 10.9651 8.16566 10.6667 8.53385 10.6667C8.90204 10.6667 9.20052 10.9651 9.20052 11.3333Z",
			fill: "#002449"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20052 8.66667C9.20052 9.03486 8.90204 9.33333 8.53385 9.33333C8.16566 9.33333 7.86719 9.03486 7.86719 8.66667C7.86719 8.29848 8.16566 8 8.53385 8C8.90204 8 9.20052 8.29848 9.20052 8.66667Z",
			fill: "#002449"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.86849 11.3333C5.86849 11.7015 5.57001 12 5.20182 12C4.83363 12 4.53516 11.7015 4.53516 11.3333C4.53516 10.9651 4.83363 10.6667 5.20182 10.6667C5.57001 10.6667 5.86849 10.9651 5.86849 11.3333Z",
			fill: "#002449"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.86849 8.66667C5.86849 9.03486 5.57001 9.33333 5.20182 9.33333C4.83363 9.33333 4.53516 9.03486 4.53516 8.66667C4.53516 8.29848 4.83363 8 5.20182 8C5.57001 8 5.86849 8.29848 5.86849 8.66667Z",
			fill: "#002449"
		})
	]
});
export default SvgXCalendaricon;
